import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=356f79c7&scoped=true&"
import script from "./DataManagement.vue?vue&type=script&lang=js&"
export * from "./DataManagement.vue?vue&type=script&lang=js&"
import style0 from "./DataManagement.vue?vue&type=style&index=0&id=356f79c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f79c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356f79c7')) {
      api.createRecord('356f79c7', component.options)
    } else {
      api.reload('356f79c7', component.options)
    }
    module.hot.accept("./DataManagement.vue?vue&type=template&id=356f79c7&scoped=true&", function () {
      api.rerender('356f79c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DataManagement.vue"
export default component.exports